import React, { useState, useEffect } from 'react';
import { useGameStore } from '../hooks/useGameStore';

export const ScreenEffects: React.FC = () => {
  const state = useGameStore();
  const [glitchOffset, setGlitchOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (state.screenEffect?.type === 'glitch') {
      const interval = setInterval(() => {
        setGlitchOffset({
          x: (Math.random() - 0.5) * 20,
          y: (Math.random() - 0.5) * 10,
        });
      }, 50);
      return () => clearInterval(interval);
    }
  }, [state.screenEffect]);

  if (!state.screenEffect) return null;

  const { type, duration } = state.screenEffect;

  const effectStyles: Record<string, React.CSSProperties> = {
    shake: {
      animation: `shakeEffect ${duration}ms ease-in-out`,
    },
    fade_black: {
      background: 'black',
      animation: `fadeIn 0.5s ease-in, fadeOut 0.5s ease-out ${duration - 500}ms`,
    },
    glitch: {
      background: `rgba(255, 0, 0, 0.05)`,
      transform: `translate(${glitchOffset.x}px, ${glitchOffset.y}px)`,
      mixBlendMode: 'screen' as const,
    },
    red_flash: {
      background: 'rgba(150, 0, 0, 0.3)',
      animation: `pulseRed ${duration}ms ease-in-out`,
    },
    static: {
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 256 256\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\' opacity=\'0.3\'/%3E%3C/svg%3E")',
      opacity: 0.5,
    },
    flicker: {
      background: 'black',
      animation: `flicker ${duration}ms steps(2, jump-none)`,
    },
  };

  return (
    <>
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        pointerEvents: 'none',
        zIndex: 1000,
        ...effectStyles[type],
      }} />
      <style>{`
        @keyframes shakeEffect {
          0%, 100% { transform: translate(0); }
          10% { transform: translate(-5px, -3px); }
          20% { transform: translate(5px, 3px); }
          30% { transform: translate(-3px, 5px); }
          40% { transform: translate(3px, -5px); }
          50% { transform: translate(-5px, 3px); }
          60% { transform: translate(5px, -3px); }
          70% { transform: translate(-3px, -5px); }
          80% { transform: translate(3px, 5px); }
          90% { transform: translate(-5px, -3px); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        @keyframes pulseRed {
          0%, 100% { opacity: 0; }
          50% { opacity: 1; }
        }
        @keyframes flicker {
          0% { opacity: 0; }
          10% { opacity: 0.8; }
          20% { opacity: 0; }
          30% { opacity: 0.6; }
          40% { opacity: 0; }
          50% { opacity: 0.9; }
          60% { opacity: 0.1; }
          70% { opacity: 0; }
          80% { opacity: 0.7; }
          90% { opacity: 0; }
          100% { opacity: 0; }
        }
      `}</style>
    </>
  );
};
